import { BottomNavigationAction, styled, Paper, Box } from '@mui/material';

export const BOTTOM_NAVIGATION_HEIGHT = '7.3rem';

export const BottomNavigationWrapperStyled = styled(Box)(({ theme }) => ({
  height: BOTTOM_NAVIGATION_HEIGHT,
  zIndex: 1020,
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: '8rem',
    position: 'fixed',
    top: '6.4rem',
    width: '100%',
  },
}));

export const BottomNavigationContentStyled = styled(Paper)(({ theme }) => ({
  // mobile
  [theme.breakpoints.down('sm')]: {
    borderTop: `0.1rem solid ${theme.palette.grey[200]}`,
    bottom: 0,
    boxShadow: 'none',
    paddingBottom: theme.spacing(4),
    position: 'fixed',
    width: '100%',
    zIndex: 1100,
  },
  // tablet
  [theme.breakpoints.up('sm')]: {
    borderBottom: `0.1rem solid ${theme.palette.grey[200]}`,
    boxShadow: 'none',
    zIndex: 1100,
    width: '100%',
    paddingLeft: '12.5%',
    paddingRight: '12.5%',
    height: '57px',
    backgroundColor: theme.palette.common.white,
  },
  // desktop
  [theme.breakpoints.up('lg')]: {
    borderBottom: `0.1rem solid ${theme.palette.grey[200]}`,
    boxShadow: 'none',
    paddingLeft: 0,
    paddingRight: 0,
    zIndex: 1100,
    width: 670,
    marginLeft: 250,
    align: 'center',
  },
}));

export const BottomNavigationActionStyled = styled(BottomNavigationAction)(
  ({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
      '&.Mui-selected': {
        borderTop: `0.4rem solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
      },
      '.MuiBottomNavigationAction-label': {
        ...theme.typography.caption,
      },
    },
    [theme.breakpoints.up('sm')]: {
      '.MuiBottomNavigationAction-label': {
        ...theme.typography.caption,
      },
      '&.Mui-selected': {
        borderBottom: `0.4rem solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main,
      },
    },
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
      flexDirection: 'row',
      maxWidth: 'none',
      '.MuiBottomNavigationAction-label': {
        paddingLeft: '1rem',
      },
    },
  })
) as typeof BottomNavigationAction;
